<template>
    <div class="notification-center widget-notification-center">
        <Transition
            name="notification"
            mode="out-in"
        >
            <Notification
                v-if="currentNotification"
                :notification="currentNotification"
            />
        </Transition>
    </div>
</template>

<script setup lang="ts">
import Notification from './Notification.vue'
import useNotifications from '@/composables/notifications/useNotifications'

const { currentNotification } = useNotifications()
</script>
